exports.API_BASE_URL='https://api.vardaanschool.org/api'
// exports.API_BASE_URL='http://localhost:4000/api'